var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("provider-table", {
        ref: "table",
        attrs: {
          url: _vm.indexUrl,
          "can-create": _vm.canCreate,
          "create-url": _vm.createUrl,
        },
      }),
      _vm._v(" "),
      _c("dialog-form-wrapper"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }